module.exports = [{"type":"title","text":"2024-06-13"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Coin-M Perpetuals new series Trading API"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-06-13.json
// module id = Jim+
// module chunks = 3